import React, { useState, useEffect, useContext } from 'react';
import { Typography, Button, TextField, Box, Stack, Select, MenuItem, FormControl } from '@mui/material';
import Layer from './Layer';
import { CanvasContext } from '../contexts/CanvasContext';
import { useDragAndDrop } from './useDragandDrop';

const GroupComponent = ({
    groupID,
    role,
    groupLayers,
    groupType,
    handleAltChange,
    selectedLayers,
}) => {

    const { primaryElementOrientation,
        layers, setLayers,
        groups, setGroups,
        activeLayers, setActiveLayers
    } = useContext(CanvasContext);
    
    // Local state to handle orientation changes
    const [orientation, setOrientation] = useState(primaryElementOrientation || "right");
    const { handleDragStart, handleDragEnter, handleDragOver, handleDrop } = useDragAndDrop(layers, setLayers, groups, setGroups);

    const collectLayerIdsInGroup = () => {
        return layers.map(layer => layer.id);
    };

    const handleOrientationChange = (event) => {
        // Update local state
        setOrientation(event.target.value);
        
        // If you need to update this in a parent component or context later,
        // you could add a prop like onOrientationChange and call it here
        // For example: if (onOrientationChange) onOrientationChange(event.target.value);
    };

    const handleLayerClick = (layer, event) => {

        // Check if the Shift key is held down during the click
        if (event.shiftKey) {
            // Update the activeLayers state
            setActiveLayers(prevActiveLayers => {
                // If the clicked layer is already active, remove it
                if (prevActiveLayers.includes(layer)) {
                    return prevActiveLayers.filter(activeLayer => activeLayer !== layer);
                } else {
                    // If the clicked layer is not active, add it
                    return [...prevActiveLayers, layer];
                }
            });
        } else {
            // If the Shift key is not held down, set the activeLayers to only the clicked layer
            setActiveLayers([layer]);
        }

        // Call highlightElementInCanvas to highlight the clicked layer
        highlightElementInCanvas("preview-" + layer.id);
        highlightElementInCanvas(layer.id);

    };

    function highlightElementInCanvas(layerId) {
        const element = document.getElementById(layerId);
        if (element) {
            if (element.style.outline === 'red solid 2px') {
                element.style.outline = ''; // Remove the highlight if it's already highlighted
                // Remove the layerId from the selectedLayers list
                const index = selectedLayers.indexOf(layerId);
                if (index > -1) {
                    selectedLayers.splice(index, 1);
                }
            } else {

                element.style.outline = 'red solid 2px'; // Highlight with a red outline
                // Add the layerId to the selectedLayers list
                if (!selectedLayers.some(item => item.layerId === layerId)) {
                    selectedLayers.push({ layerId, altText: element.alt });
                }
            }
        } else {
            console.log(`Element not found: ${layerId}`);
        }
    }

    return (
        <div>
            <div
                onDragOver={handleDragOver}
                onDrop={(e) => handleDrop(e, groupID, role)}

            >
                <div style={{ width: "100%" }}>

                    <Stack direction="row">
                        <Stack direction="row" >
                            <img style={{ height: "12px", top: "6px", marginRight: "12px", position: "relative" }} src="https://cdn-icons-png.flaticon.com/512/20/20972.png">
                            </img>
                            <img style={{ height: "12px", top: "6px", marginRight: "12px", position: "relative" }} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcjwaxUpzSwIqDPewEigkxtrTAnPuDdJWrh7CWD0cTLgbL0HQHhcoUffDRoSs2mW6KnWM&usqp=CAU">
                            </img>

                            <Typography variant="body1">{capitalizeFirstLetter(groupType)} Group</Typography>
                        </Stack>

                    </Stack>

                    <Box sx={{ width: "90%", float: "right" }}>

                        {groupLayers.filter(layer => layer.role === role).map((layer) => (
                            <Layer
                                key={layer.id} 
                                layer={layer}
                                onAltChange={handleAltChange}
                                onClick={(event) => handleLayerClick(layer, event)}
                                onDragStart={(e) => handleDragStart(e, layer, groupID, role)}
                                onDragEnter={(e) => handleDragEnter(e, groupID, role)}
                                role={role}
                            />
                        ))}

                        {groupType === "primary" && (
                            <div style={{ display: 'flex', alignItems: 'center', gap:'1em', textAlign: 'center', margin:'0.5em', marginLeft:'0.8em' }}>
                                <Typography variant="body1">Element Faces:</Typography>
                                <FormControl size="small" sx={{ minWidth: 60 }}>
                                    <Select
                                        value={orientation}
                                        onChange={handleOrientationChange}
                                        displayEmpty
                                        variant="outlined"
                                        sx={{ height: '2em' }}
                                    >
                                        <MenuItem value="left">Left</MenuItem>
                                        <MenuItem value="right">Right</MenuItem>
                                        <MenuItem value="up">Up</MenuItem>
                                        <MenuItem value="down">Down</MenuItem>
                                        <MenuItem value="front">Front</MenuItem>

                                    </Select>
                                </FormControl>
                            </div>
                        )}

                       
                    </Box>

                </div>
            </div>
        </div>
    );
};

const capitalizeFirstLetter = (str) => {
    console.log(str);
    if (str === 'default') {
        return 'Default';
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export default GroupComponent;